import { newUuid } from '@krp/client-runtime'

/** GUID операции — генератор client-runtime (с запасным путём вне secure context). */
export const newOperationId = (): string => newUuid()
